import { Box } from "@mui/material";
import UserProfileComponent from "../../components/profile/profile";
function UserProfilePage() {
  return <Box>{<UserProfileComponent />}</Box>;
}

export default UserProfilePage;
